import { useEffect } from 'react';
import { useLocation } from 'wouter';

/**
 * ScrollToTop - Scrolls to top of page on route changes
 *
 * Place this component inside the Router to automatically
 * scroll to top when navigating between pages.
 */
export function ScrollToTop() {
  const [location] = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return null;
}
